import Card from './Card'
import { Link } from 'react-router-dom';
import Loading from './Loading';

const Blog = ({label, data, loading}) => {
  let url = (label === 'Projects' ? '/projects' : '/articles');
  return (
    <div>
      <h3 className='container-title'>My {label}</h3>
      {loading? <Loading /> :
        (<div className='blog__container'>
          {data === undefined? '' : data.map(project => (
            <Card key={project.id} id={project.id} image_url={project.image_url} label={label} title={project.title} status_description={project.short_description} status={project.project_type} hashtag={project.project_type} />
            ))}
        </div>)
      }
      <div className='d-flex w-100 my-5'>
        <Link to={url} className='about-btn m-auto'>See More</Link>
      </div>
    </div>
  );
}

export default Blog;